import { render } from "./CustomAdditional.vue?vue&type=template&id=66b530e6"
import script from "./CustomAdditional.vue?vue&type=script&lang=js"
export * from "./CustomAdditional.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__